export const LIMIT_ITEM = 9;
export const INVOICE_LIMIT = 10;
export const LIMIT_ITEM_TABLE = 10;
export const LIMIT_ITEM_NEWS = 4;
export const LIMIT_ITEM_WARNING = 12;
export const LIMIT_ITEM_BLOGS = 3;
